import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_BMODELS = "bmodels";
const BASE_URL = "/api/bmodels";

const BmodelsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const BMODELS_EMPTY = {
    provincie: "",
    sector: "",
    club: "",
    stamnr: "",
    gestichtin: "",
    vzw: "",
    ondernemingsNummer: "",
    url: "",
    email: "",
    eigenaar: "",
    bankVerbinding: "",
    opnaamVan: "",
    naamSchuttersLokaal: "",
    adres: "",
    telefoon: "",
    gsm: "",
    fax: "",
    naamVoornaamVoorzitter: "",
    straatNrVoorzitter: "",
    postnrVoorzitter: "",
    telgsmemailVoorzitter: "",
    naamVoornaamOnderVoorzitter: "",
    straatNrOnderVoorzitter: "",
    postnrOnderVoorzitter: "",
    telgsmemailOnderVoorzitter: "",
    naamVoornaamSecretaris: "",
    straatNrSecretaris: "",
    postnrSecretaris: "",
    telgsmemailSecretaris: "",
    naamVoornaamPenningsmeester: "",
    straatNrPenningsmeester: "",
    postnrPenningsmeester: "",
    telgsmemailPenningsmeester: "",
    naamVoornaamTechnischCommisaris: "",
    straatNrTechnischCommisaris: "",
    postnrTechnischCommisaris: "",
    telgsmemailTechnischCommisaris: "",
    naamVoornaamCommisaris1: "",
    straatNrCommisaris1: "",
    postnrCommisaris1: "",
    telgsmemailCommisaris1: "",
    naamVoornaamCommisaris2: "",
    straatNrCommisaris2: "",
    postnrCommisaris2: "",
    telgsmemailCommisaris2: "",
    naamVoornaamCommisaris3: "",
    straatNrCommisaris3: "",
    postnrCommisaris3: "",
    telgsmemailCommisaris3: "",
    verwerkt: ""
};

export function useBmodels() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_BMODELS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...BmodelsQueryConfig
    });
    return {...result, bmodels: result.data};
}


export function useBmodel(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_BMODELS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...BmodelsQueryConfig
    });
    return {...result, bmodel: result.data};
}

export function useBmodelMutations() {
    async function createFunction(bmodel) {
        if (!bmodel) return;
        return await fetchPOST(BASE_URL, bmodel, false);
    }

    async function editFunction(bmodel) {
        if (!bmodel) return;
        return await fetchPUT(`${BASE_URL}/${bmodel.id}`, bmodel);
    }

    async function editAddNewFiles(bmodel) {
        if (!bmodel) return;
        return await fetchPUT(`${BASE_URL}/${bmodel.id}/files`, bmodel.fileId);
    }

    async function deleteFunction(bmodel) {
        return await fetchDELETE(`${BASE_URL}/${bmodel.id}`)
    }

    return {
        createBmodel: useMyMutation(createFunction, REACT_QUERY_ID_BMODELS, bmodel => `Bmodel ${bmodel.title} created`),
        editBmodel: useMyMutation(editFunction, REACT_QUERY_ID_BMODELS, bmodel => `Bmodel ${bmodel.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_BMODELS, bmodel => `Bmodel ${bmodel.title} modified`),
        deleteBmodel: useMyMutation(deleteFunction, REACT_QUERY_ID_BMODELS, bmodel => `Bmodel ${bmodel.title} deleted.`)
    };

}